<h2 mat-dialog-title>How to find it — {{ data.systemName }}</h2>

<mat-dialog-content class="gd-content">

  <div class="gd-empty" *ngIf="loading">Loading…</div>

  <ng-container *ngIf="!loading">
    <p class="gd-note">
      What a driver who has <strong>never been here</strong> needs: which entrance, which floor,
      what the spot looks like. This shows up in the driver app at this stop.
    </p>

    <div class="gd-row">
      <mat-form-field appearance="outline" class="gd-field-sm">
        <mat-label>Floor</mat-label>
        <input matInput [(ngModel)]="floor" placeholder="2nd floor / underetasje">
      </mat-form-field>

      <mat-form-field appearance="outline" class="gd-field">
        <mat-label>Entrance</mat-label>
        <input matInput [(ngModel)]="entranceNote" placeholder="Use goods entrance on the back, ring bell B">
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="gd-full">
      <mat-label>Parking</mat-label>
      <input matInput [(ngModel)]="parkingNote" placeholder="Van fits behind the loading dock; do NOT use visitor spots">
    </mat-form-field>

    <mat-form-field appearance="outline" class="gd-full">
      <mat-label>Directions inside the building</mat-label>
      <textarea matInput rows="3" [(ngModel)]="directions"
                placeholder="Through the glass doors, past reception, canteen is at the end of the corridor on the left"></textarea>
    </mat-form-field>

    <!-- Who changed the text, and when. Drivers edit live from the app, so
         this is where a wrong edit is spotted and put back. -->
    <details class="gd-history" *ngIf="editRows.length">
      <summary>Change history ({{ editRows.length }})</summary>
      <div class="gd-edit" *ngFor="let r of editRows; trackBy: trackByEdit">
        <div class="gd-edit-head">
          <span [class.gd-driver]="r.isDriver">{{ r.who }}</span>
          <span class="gd-edit-when">{{ r.when }}</span>
          <button mat-button type="button" class="gd-revert" (click)="revert(r)">Revert</button>
        </div>
        <div class="gd-edit-change" *ngFor="let c of r.changes">
          <strong>{{ c.label }}:</strong>
          <span class="gd-old">{{ c.before || '(empty)' }}</span> → <span>{{ c.after || '(empty)' }}</span>
        </div>
      </div>
    </details>

    <!-- The pins. Click the map to place the selected one; drag to adjust.
         Drivers can also move both from the app, standing on the spot. -->
    <div class="gd-pins-head">
      <button type="button" class="gd-pin-tab gd-pin-parking" [class.on]="selected === 'parking'"
              (click)="selected = 'parking'">
        Parking pin <span class="gd-pin-coord">{{ pinLabel('parking') }}</span>
      </button>
      <button type="button" class="gd-pin-tab gd-pin-entrance" [class.on]="selected === 'entrance'"
              (click)="selected = 'entrance'">
        Entrance pin <span class="gd-pin-coord">{{ pinLabel('entrance') }}</span>
      </button>
    </div>
    <div class="gd-pin-meta">
      <span *ngIf="pinSetBy[selected]">{{ pinSetBy[selected] }}</span>
      <button type="button" class="gd-clear" *ngIf="pins[selected]" (click)="clearPin(selected)">
        Remove {{ selected }} pin
      </button>
    </div>

    <div class="gd-map-wrap">
      <div #mapEl class="gd-map"></div>
      <button type="button" class="gd-base" (click)="toggleBase()">
        {{ base === 'sat' ? 'Street map' : 'Satellite' }}
      </button>
    </div>
    <p class="gd-map-hint">Click the map to place the <strong>{{ selected }}</strong> pin, or drag a pin to move it.</p>

    <mat-form-field appearance="outline" class="gd-full">
      <mat-label>…or paste "lat, lng" / a Google Maps link for the {{ selected }} pin</mat-label>
      <input matInput [(ngModel)]="pinText" (keyup.enter)="parsePin()" (blur)="parsePin()"
             placeholder="59.744123, 10.204456">
      <mat-hint class="gd-error" *ngIf="pinError">{{ pinError }}</mat-hint>
    </mat-form-field>

    <div class="gd-photos-head">
      <strong>Photos</strong>
      <label class="gd-upload" [class.gd-upload-busy]="uploading">
        {{ uploading ? 'Uploading…' : '+ Add photo' }}
        <input type="file" accept="image/*" hidden (change)="onFilePicked($event)" [disabled]="uploading">
      </label>
    </div>

    <div class="gd-photos" *ngIf="photos.length">
      <div class="gd-photo" *ngFor="let p of photos; trackBy: trackByPhoto">
        <img [src]="p.url" [alt]="p.caption || 'Location photo'">
        <input class="gd-caption" [(ngModel)]="p.caption" placeholder="Caption…">
        <div class="gd-photo-foot">
          <span class="gd-attribution" [class.gd-driver]="p.source === 'driver'">{{ photoAttribution(p) }}</span>
          <button mat-icon-button (click)="removePhoto(p)" matTooltip="Remove photo">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="gd-empty" *ngIf="!photos.length">
      No photos yet. Drivers can also add them from the app, standing at the machine.
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="saving || loading">
    {{ saving ? 'Saving…' : 'Save guide' }}
  </button>
</mat-dialog-actions>
